import { Skeleton } from '@mui/material';
import { FC, memo } from 'react';
import { PatientDetails, PatientInfo, PatientInfoWrapper, PatientName } from './contact-info/contact-info.styles';
import { HeaderWrapper } from './header.styles';

export const PatientProfileHeaderSkeleton: FC = memo(() => (
  <HeaderWrapper>
    <PatientInfoWrapper>
      <PatientInfo>
        <PatientName>
          <Skeleton variant="rounded" width={50} height={24} sx={{ marginRight: '10px' }} />
          <Skeleton variant="rounded" width={100} height={24} sx={{ marginRight: '10px' }} />
          <Skeleton variant="rounded" width={30} height={24} />
        </PatientName>
        <PatientDetails>
          <Skeleton variant="rounded" width={20} height={14} />
          <Skeleton variant="circular" width={4} height={4} sx={{ margin: '0 6px' }} />
          <Skeleton variant="rounded" width={80} height={14} />
          <Skeleton variant="circular" width={4} height={4} sx={{ margin: '0 6px' }} />
          <Skeleton variant="rounded" width={120} height={14} />
        </PatientDetails>
      </PatientInfo>
    </PatientInfoWrapper>
  </HeaderWrapper>
));
